import axios from 'axios';
import {
    GET_NOTIFICATIONS,
    NOTIFICATIONS_ERROR,
    MARK_NOTIFICATIONS_READ,
    DISMISS_NOTIFICATION,
    UPDATE_HOST_ME,
    UPDATE_ATTENDEE_ME,
    UPDATE_ARTIST_ME,
} from './types';

export const getNotifications = () => async (dispatch) => {
    try {
        const res = await axios.get('/api/notifications');
        dispatch({
            type: GET_NOTIFICATIONS,
            payload: res.data,
        });
    } catch (err) {
        dispatch({
            type: NOTIFICATIONS_ERROR,
            payload: {
                msg: err.response?.statusText,
                status: err.response?.status,
            },
        });
    }
};

export const markNotificationsRead =
    (ids) =>
    async (dispatch) => {
        try {
            const config = {
                headers: { 'Content-Type': 'application/json' },
            };
            const res = await axios.post(
                '/api/notifications/read',
                { ids: Array.isArray(ids) ? ids : [] },
                config
            );
            dispatch({
                type: MARK_NOTIFICATIONS_READ,
                payload: res.data,
            });
        } catch (err) {
            dispatch({
                type: NOTIFICATIONS_ERROR,
                payload: {
                    msg: err.response?.statusText,
                    status: err.response?.status,
                },
            });
        }
    };

export const dismissNotifications =
    (ids) =>
    async (dispatch) => {
        try {
            const config = {
                headers: { 'Content-Type': 'application/json' },
            };
            const res = await axios.post(
                '/api/notifications/dismiss',
                { ids: Array.isArray(ids) ? ids : [] },
                config
            );
            dispatch({
                type: DISMISS_NOTIFICATION,
                payload: res.data,
            });
        } catch (err) {
            dispatch({
                type: NOTIFICATIONS_ERROR,
                payload: {
                    msg: err.response?.statusText,
                    status: err.response?.status,
                },
            });
        }
    };

export const updateNotificationFrequency =
    (hat, notificationFrequency) =>
    async (dispatch) => {
        try {
            const config = {
                headers: { 'Content-Type': 'application/json' },
            };
            const res = await axios.post(
                '/api/notifications/frequency',
                { hat, notificationFrequency },
                config
            );
            const { hat: savedHat, profile } = res.data || {};
            if (savedHat === 'HOST') {
                dispatch({ type: UPDATE_HOST_ME, payload: profile });
            } else if (savedHat === 'ATTENDEE') {
                dispatch({ type: UPDATE_ATTENDEE_ME, payload: profile });
            } else if (savedHat === 'ARTIST') {
                dispatch({ type: UPDATE_ARTIST_ME, payload: profile });
            }
            return profile;
        } catch (err) {
            dispatch({
                type: NOTIFICATIONS_ERROR,
                payload: {
                    msg: err.response?.statusText,
                    status: err.response?.status,
                },
            });
            return null;
        }
    };
